import React from 'react';

export default ({ classes, value, left, right, top }) => {
  const style = {};
  if (left) style.left = left;
  if (right) style.right = right;

  return (
    <div
      className={`fuzzy-val ${classes.inline} ${classes.absolute}`}
      style={{
        ...style,
        top,
        zIndex: 1,
        overflow: 'hidden', textOverflow: 'ellipsis'
      }}
      title={value}
    >
      <span
        className={`${classes.nowrap}`} //${classes.fuzzyVal} 
        style={{ right: 0, backgroundColor: '#fff', color: '#4c4c4c', opacity: 0.7, fontSize: '10px', marginBottom: '24px', //display: show ? 'block' : ''
        }}>
        &ldquo;{value}&rdquo;
      </span>
      {/* <span
        className={`fuzzy-option-mark`}
        style={{ color: '#DD5900', margin: '-4px -8px 24px', display: show ? 'none' : '' }}
      >&#12290;</span> */}
    </div>
  );
};
